module.exports = __webpack_public_path__ + "img/彩田分校@2x.48aa2569.png";